// extracted by mini-css-extract-plugin
module.exports = {"fieldsContainer":"EducationFeedbackForm_fieldsContainer__iQXiC","checkboxContainer":"EducationFeedbackForm_checkboxContainer__pWy6X"};